import Ajax from './ajax';
export default {
  // 获取监控室监控任务
  GETmonitorRound(param) {
    return Ajax.get(`/api/grade/v1/monitorroom/exam/monitor/round`);
  },
  // 根据获取监控统计ID
  POSTstatistic(param = {}) {
    return Ajax.post(`/api/grade/v1/monitorroom/exam/monitor/statistic`, { ...param });
  },
  // 获取标准化考场统计详情
  GETstatisticDetail(param) {
    return Ajax.get(`/api/grade/v1/monitorroom/exam/monitor/statistic/${param.statisticId}`);
  },
  // 更新标准化考场视频监控方式
  POSTmonitortype(param = {}) {
    return Ajax.post(`/api/grade/v1/monitorroom/exam/monitor/config/monitortype`, { ...param });
  },
  // 更新标准化考场轮训方式
  POSTlooptype(param = {}) {
    return Ajax.post(`/api/grade/v1/monitorroom/exam/monitor/config/looptype`, { ...param });
  },
};
